import { isCodeRepoResource, isImageResource } from "@/domain/resource"
import {
  getResourceDrawer,
  getStandInApplicationId
} from "@/helpers/application-source.helper"
import { preventDefaultWrapper } from "@/helpers/utils"
import {
  CODE_REPOSITORY_DRAWER_ID,
  IMAGE_DRAWER_ID
} from "@/organisms/Drawers/const"
import { Resource } from "."

import styles from "./Resources.module.scss"

import type { ActionOpenDrawer } from "@/hooks/useLinkDrawerTooltip"
import type { ResourcesProps } from "."

export const ContentResourcesPopover = (
  props: Pick<ResourcesProps, "resources" | "allowImageLink"> & {
    openDrawer?: ActionOpenDrawer
  }
) => (
  <div className={styles.containerTooltip} onClick={preventDefaultWrapper()}>
    {props.resources.map((resource, index) => {
      const { openDrawer, allowImageLink } = props
      const isCodeRepo = isCodeRepoResource(resource)
      const isImage = isImageResource(resource)
      // A resource standing in for an application opens the application drawer,
      // even where images don't link
      const isApplication = !!getStandInApplicationId(resource)
      const shouldOpenDrawer =
        (isCodeRepo || isApplication || (isImage && allowImageLink)) &&
        openDrawer
      const { drawerId, key } = getResourceDrawer(
        resource,
        isCodeRepo ? CODE_REPOSITORY_DRAWER_ID : IMAGE_DRAWER_ID
      )
      const onClick = shouldOpenDrawer
        ? preventDefaultWrapper(() => openDrawer(drawerId, key))
        : undefined

      return <Resource key={index} onClick={onClick} {...resource} />
    })}
  </div>
)
